import { defineStore } from "pinia";
import http from "@/http";
import { LIST_INSTRUMENTO, ADD_INSTRUMENTO, UPDATE_INSTRUMENTO, DEL_INSTRUMENTO } from "@/http/url";

export const useInstrumentoStore = defineStore("InstrumentoStore", {
  state: () => {
    return {
      instrumentos: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_INSTRUMENTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_INSTRUMENTO)
          .then((response) => {
            this.instrumentos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_INSTRUMENTO(instrumento) {
      return http
        .post(ADD_INSTRUMENTO, instrumento)
        .then((response) => this.instrumentos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_INSTRUMENTO(instrumento) {
      return http.put(`${UPDATE_INSTRUMENTO + instrumento.id}`, instrumento);
    },

    REMOVER_INSTRUMENTO(id) {
      return http
        .delete(`${DEL_INSTRUMENTO + id}`)
        .then(() => (this.instrumentos = this.instrumentos.filter((i) => i.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getInstrumentos() {      
      return this.instrumentos;
    },

    getInstrumentoLoad(state) {
      return state.loaded;
    },

    getFilterInstrumentos: (state) => {
      return (filtro) => state.instrumentos.filter((i) => !filtro || i.descricao.includes(filtro));
    },
  },
});